<template>
  <div class="home-page info-component">
    <div class="success-greeting" v-if="greetingInfo && levelStatus === 'success'">
      <div class="success-greeting-inner" v-if="!showLogin">
        <greetings-message
          :currentLevel="currentLevel"
          :greetingInfo="greetingInfo"
          :userGameInfo="userGameInfo"
          :userTotalPoints="userTotalPoints"
          :gameContent="gameContent"
          :mobileView="mobileView"
          @proceedToQuiz="$emit('proceedToQuiz')"
        ></greetings-message>
      </div>
    </div>
    <div class="user-failed" v-else-if="greetingInfo && levelStatus === 'failure'">
      <div
        class="failure-greeting"
        v-if="userGameInfo[currentLevel.name]"
        :style="{ 'background-image': 'url(' + (mobileView ? greetingInfo.mobile_image : greetingInfo.desktop_image) + ')' }"
      >
        <div class="content animate-slidein">
          <h3>{{ greetingInfo.message }}</h3>
          <h5>{{ greetingInfo.hint }}</h5>
          <div class="score-info">
            <img :src="gameContent.logo" alt="logo" />
            <div class="txt">Heildarstig</div>
            <div class="total">{{ userTotalPoints }}</div>
            <div class="divider"></div>
            <div class="out-of">Þú svaraðir {{ Object.values(userGameInfo[currentLevel.name]).filter(Boolean).length }} af {{ Object.values(userGameInfo[currentLevel.name]).length }} spurningum rétt</div>
            <status-bar :answerSheet="Object.values(userGameInfo[currentLevel.name])" />
          </div>
        </div>
        <button
          type="button"
          class="button animate-slidein"
          @click="$emit('proceedToQuiz', true)"
        >
          {{ greetingInfo.cta_links[0].text }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { UserInfo } from '@/shared/dataModels'
export default {
  name: 'InfoComponent',
  props: {
    'currentLevel': {
      type: Object,
      default () {
        return {}
      }
    },
    'levelStatus': {
      type: String,
      default: null
    },
    'goldCompleted': {
      type: Boolean,
      default: false
    },
    'showSucccessGreeting': {
      type: Boolean,
      default: false
    },
    'userTotalPoints': {
      type: Number,
      default: 0
    },
    userGameInfo: {},
    greetingInfo: null,
  },
  data () {
    return {
      questionIndex: 0,
      userInfo: new UserInfo(),
      userClub: null,
      clubImage: null,
      dataReady: false,
      goldLevel: null,
      showLogin: false,
      showFacebookList: false,
      nextUrl: null,
      showFacebook: false,
      gameContent: {},
      mobileView: window.innerWidth < 768,
    }
  },
  created () {
    window.addEventListener('resize', this.handleResize);
    if (this.$data.globalData && this.$data.globalData.user) {
      this.userInfo = this.$data.globalData.user
      if (this.$data.globalData.user.user_club) {
        this.userClub = this.$data.globalData.user.user_club
        this.showJoinClub = false
        if (this.$data.globalData.user.user_club.image_url) {
          this.clubImage = this.$data.globalData.user.user_club.image_url
        }
      }
    }
    if (this.$route.query && this.$route.query.next_url) {
      this.nextUrl = this.$route.query.next_url
    }
    if (this.$data.globalData && this.$data.globalData.gameContent) {
      this.gameContent = this.$data.globalData.gameContent
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  mounted () {
    if (this.levelStatus && this.currentLevel) {
      this.greetingsMessage()
    }
  },
  methods: {
    proceed () {
      window.location.href = '/spurningar/'
    },
    list () {
      window.location.href = '/list/'
    },
    facebookList () {
      this.showFacebookList = true
    },
    proceedToQuiz () {
      this.$emit('proceedToQuiz', true)
    },
    greetingsMessage() {
      if (this.levelStatus === 'success') {
        setTimeout(() => {
          if (this.userInfo.medal_subscribed) {
            this.$router.replace('/fb/share/')
          } else {
            // this.$router.replace('/medal-form-r2020') // Disbaled for now
            this.$router.replace('/fb/share/')
          }
        }, 5000)
      }
    },
    handleResize() {
      this.mobileView = window.innerWidth < 768
    }
  },
}
</script>

<style lang="scss" scoped>
.greetings-text {
  .sub-text {
    font-size: 18px;
    line-height: 140%;
    max-width: 500px;
    margin: 0 auto;
    padding-bottom: 5rem;
  }
}
.user-failed {
  text-align: center;
  height: 100%;
  .failure-greeting {
    padding: 94px 18px 83px;
    display: flex;
    align-items: center;
    flex-direction: column;
    height: 100%;
    background-size: cover;
    overflow: auto;
    background-position: bottom;
    .content {
      margin-bottom: 20px;
      h3 {
        font-weight: 600;
        font-size: 32px;
        line-height: 38px;
        color: #FFFFFF;
        margin-bottom: 8px;
      }
      h5 {
        font-weight: 400;
        font-size: 14px;
        line-height: 17px;
        color: #FFFFFF;
        margin-bottom: 74px;
      }
      .score-info {
        background: #FFFFFF;
        border-radius: 10px;
        padding: 16px 16px 18px;
        position: relative;
        color: #011627;
        width: 308px;
        margin: auto;
        box-shadow: 0px 0px 50px rgba(0, 0, 0, 0.1);
        img {
          width: 65px;
          height: 65px;
          margin-bottom: 4px;
          position: absolute;
          top: -55px;
          left: 50%;
          transform: translateX(-50%);
        }
        .txt {
          font-weight: 400;
          font-size: 12px;
          line-height: 132%;
        }
        .total {
          font-weight: 600;
          font-size: 42px;
          line-height: 132%;
          margin-bottom: 15px;
        }
        .divider {
          border: 0.5px solid #C4C4C4;
          width: 234px;
          margin: auto;
          margin-bottom: 17px;
        }
        .out-of {
          font-weight: 400;
          font-size: 12px;
          line-height: 132%;
          margin-bottom: 7px;
        }
        .status-page {
          /deep/.status-bar-inner {
            height: 20px;
            width: 20px;
            margin: 0 calc(4px / 2);
          }
        }
      }
    }
    .button {
      font-size: 18px;
      line-height: 22px;
      max-width: 338px;
      width: 100%;
    }
  }
  .player-img {
    padding: 2rem 0;
  }
  .failure {
    font-weight: 600;
    font-size: 35px;
    line-height: 42px;
    margin: 0;
    color: #011627;
  }
  .sub-text {
    font-weight: normal;
    font-size: 18px;
    line-height: 140%;
    color: #011627;
  }
}
.level-failed-img {
  max-width: 200px;
  margin: 0 auto;
}
.info-component {
  // padding: 7rem 0;
  // min-height: 600px;
}
.sub-text {
  padding: 10px 50px;
}
.row {
  margin-right: 0;
  margin-left: 0;
}
.success-greeting, .success-greeting-inner {
  height: 100%;
}

@media screen and (max-width: 767px) {
  .level-failed-img {
    width: 160px;
    height: 207px;
    margin: 0 auto;
  }
  .user-failed {
    .failure {
      font-size: 32px;
      padding: 0 6px;
    }
    .failure-greeting {
      padding-top: 10rem;
      .content {
        .score-info {
          .status-page {
            /deep/.status-bar-inner {
              height: 14px;
              width: 14px;
            }
          }
        }
      }
    }
  }
}

</style>
<style lang="scss">
  .el-input--suffix {
    .el-input__inner {
      background: #F3F3EF;
      border: 1px solid #D8D8C6;
      box-sizing: border-box;
      padding: 25px 40px;
    }
  }
  .el-select {
    .el-input__inner {
      border-radius: 0;
    }
  }
  .alert-message-outer {
    max-width: 900px;
    margin: 0 auto;
    .el-alert--warning {
      background: #FFE1E1;
      color: #011627;
      border-radius: 13px;
      padding: 15px 20px;
      .el-icon-warning:before {
        color: #FF6A6A;
      }
      .el-alert__closebtn {
        color: #011627;
        display: none;
        top: 23px;
        width: 16px;
        height: 16px;
      }
    }
  }
</style>